import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M11.56 7.353A6.19 6.19 0 0 1 7.647 3.44a.155.155 0 0 0-.294 0A6.19 6.19 0 0 1 3.44 7.353a.155.155 0 0 0 0 .294 6.19 6.19 0 0 1 3.913 3.913.155.155 0 0 0 .294 0 6.19 6.19 0 0 1 3.913-3.913.155.155 0 0 0 0-.294m1.049 9.517a5.5 5.5 0 0 1-3.479-3.48.138.138 0 0 0-.26 0 5.5 5.5 0 0 1-3.48 3.48.138.138 0 0 0 0 .26 5.5 5.5 0 0 1 3.48 3.48.137.137 0 0 0 .26 0 5.5 5.5 0 0 1 3.479-3.479.137.137 0 0 0 0-.26m8.804-5.067a8.25 8.25 0 0 1-5.217-5.217.206.206 0 0 0-.392 0 8.25 8.25 0 0 1-5.217 5.217.206.206 0 0 0 0 .392 8.25 8.25 0 0 1 5.217 5.217.206.206 0 0 0 .392 0 8.25 8.25 0 0 1 5.217-5.217.206.206 0 0 0 0-.392"
    }
  )
);
var SvgSparklesFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SparklesFilled_default = SvgSparklesFilled;

export { SparklesFilled_default as default };
